import PropTypes from 'prop-types';
import IconSvg from 'Components/IconSvg';

const EmptyRecommendations = ({ strings }) => (
  <div className="empty-recommendations">
    <div className="empty-recommendations-msg">
      <IconSvg type="error" />
      <p>{strings.recommendationsError}</p>
    </div>
  </div>
);

EmptyRecommendations.propTypes = {
  strings: PropTypes.object.isRequired,
};

EmptyRecommendations.defaultProps = {};

export default EmptyRecommendations;
